import axios from "axios";
import { apiClient } from "./lib";
import { OptionType } from "./shared/context/FilterContext";

export const masterDataApi = {
    fetch: async (): Promise<any> => {
        const response = await apiClient.get('/master-data/get-all-data');
        return response.data;
    }
};

export const userCapabilitiesApi = {
    fetch: async (): Promise<any> => {
        const response = await apiClient.get('/roles/layout');
        return response.data.data;
    }
};

export const filterMapApi = {
    fetch: async (): Promise<any> => {
        const response = await apiClient.get('/filter-map');
        return response.data.data;
    }
};

export const fetchQuickFilterDetails = {
    fetch: async (apiEndPoint: OptionType): Promise<any> => {
        const response = await apiClient.get(apiEndPoint === 'phases' ? 'phases?is_active=true' : apiEndPoint);
        return response.data;
    }
};

export const reverseGeocode = {
    fetch: async (params?: any): Promise<any> => {
        const response = await apiClient.get('/master-data/get-all-data', {
            params: {
                ...params,
            },
        });
        return response.data;
    }
};

export const preSignFetch = {
    fetch: async (params?: any): Promise<any> => {
        const response = await apiClient.get(`/file?&id=${params.objectId}&object_type=${params.fileType}`);
        return response.data;
    }
};

export const preSignDownload = {
    fetch: async (params?: any): Promise<any> => {
        const response = await apiClient.post('/file/get-pre-signed', params)
        return response.data;
    }
};

export const preSignDelete = {
    fetch: async (params?: any): Promise<any> => {
        const response = await apiClient.delete('/file/delete-pre-signed', { data: params })
        return response.data;
    }
};

export const preSignUpload = {
    fetch: async (params?: any): Promise<any> => {
        const response = await apiClient.post('/file/post-pre-signed', params)
        return response.data;
    }
};

export const preSignUploadAWS = {
    fetch: async (params?: any): Promise<any> => {
        const response = await axios.post(params.url, params.fields)
        return response.data;
    }
};

export const preSignEntry = {
    fetch: async (params?: any): Promise<any> => {
        const response = await apiClient.post('/file/upload-entry', params)
        return response.data;
    }
};

export const preSignEntryPatch = {
    fetch: async (params?: any): Promise<any> => {
        const response = await apiClient.patch('/file/upload-entry', params)
        return response.data;
    }
};